import React from 'react';
import { isMobile } from '../../util/ScreenUtil';
import ThumbnailUtil from '../../util/ThumbnailUtil';
import System from '../../basic/System';

export default class HomeBanner extends React.Component {
  render() {
    const height = isMobile() ? window.innerHeight / 2 : 380;
    const backgroundImage = window.homeHeaderExists
      ? `url(${this.getHomeHeaderPicUrl()})`
      : 'url(images/home_header.jpg)';
    return (
      <div style={{ position: 'relative', height, backgroundImage, backgroundSize: 'cover' }} name="HomeBanner">
        <div style={styles.companyDetails}>
          <span style={styles.companyName}>{window.gs.companyName}</span>
          <span style={styles.companyTagLine}>{window.gs.companyTagLine}</span>
        </div>
      </div>
    );
  }

  getHomeHeaderPicUrl() {
    if (System.isDesktop()) return window.homeHeaderExists;
    return ThumbnailUtil.getHomeHeaderPicUrl();
  }
}

const styles = {
  companyDetails: {
    color: '#B5B5B5',
    position: 'absolute',
    bottom: '20px',
    textAlign: 'center',
    width: '100%'
  },
  companyName: {
    display: 'block',
    marginBottom: '11px',
    height: '29px',
    color: '#FFFFFF',
    fontSize: '24px',
    fontWeight: '600',
    lineHeight: '29px',
    textAlign: 'center',
    textShadow: '2px 2px #333'
  },
  companyTagLine: {
    height: '19px',
    color: '#B5B5B5',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '19px',
    textAlign: 'center',
    textShadow: '-1px 1px #333'
  }
};
